<template>
  <div class="head-wrap">
    <el-avatar
      :class="[sex == '0' ? 'border-girl' : 'border-boy']"
      :size="50"
      :src="avatar"
    ></el-avatar>
    <div class="head-title">
      <div>
        {{ studentInfo.studentName }} {{ studentInfo.monthAge }}个月
        {{ sex == "0" ? "女" : "男" }}
      </div>
      <div>{{ reportTime }}</div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    ReportData() {
      return this.$store.state.ReportData || {};
    },
    avatar() {
      let url = (this.ReportData.orgLogo || {}).avatar;
      if (url) {
        return this.$g.host + url;
      } else {
        return null;
      }
    },
    studentInfo() {
      return this.ReportData.studentInfo || {};
    },

    reportTime() {
      return this.studentInfo.reportTime;
    },
    sex() {
      return this.studentInfo.sex || "0";
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/themes/var.scss";
.border-boy {
  border: 3px solid $boy-color;
}
.border-girl {
  border: 3px solid $girl-color;
}
.head-wrap {
  .el-avatar {
    background: transparent;
  }
  padding: 20px 15px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f5f5f5;
  .head-title {
    margin-left: 20px;
  }
}
</style>